export interface Boleto {
  id: string;
  vencimento: string;
  valor: number;
  diasAtraso: number;
  juros: string;
  multa: number;
  valorCorrigido: number;
  selecionada: boolean;
  desabilitada: boolean;
  base64?: string;
  arquivo_base64?: string;
  codigoBarras?: string;
  prefixo_titulo?: string;
  numero_titulo?: string;
  parcela_titulo?: string;
}

export interface BoletoItemPF {
  prefixo: string;
  numero: string | null;
  parcela: string;
  vencimento: string;
  valor: number;
  codigoBarras: string | null;
  base64: string;
}

export type BoletoApiResponsePF = BoletoItemPF | BoletoItemPF[];

export interface BoletoItemPJ {
  id: string | null;
  prefixo_titulo: string;
  numero_titulo: string;
  parcela_titulo: string;
  vencimento: string;
  valor: number;
  codigo_barras: string | null;
  numero_pedido_venda: string | null;
  nome_arquivo: string | null;
  arquivo_base64: string | null;
}

export interface BoletoApiResponsePJ {
  dados: {
    boleto: BoletoItemPJ[];
  };
  status: string;
  mensagem: string;
}

export interface BoletoItem {
  id: string | null;
  prefixo_titulo: string;
  numero_titulo: string;
  parcela_titulo: string;
  vencimento: string;
  valor: number;
  codigo_barras: string | null;
  numero_pedido_venda: string | null;
  nome_arquivo: string | null;
  arquivo_base64: string | null;
}

export interface BoletoApiResponse {
  dados: {
    boleto: BoletoItem[];
  };
  status: string;
  mensagem: string;
}

export const mapApiResponsePFToBoleto = (apiResponse: BoletoApiResponsePF, isFirstItemDisabled: boolean = true): Boleto[] => {
  const boletos = Array.isArray(apiResponse) ? apiResponse : [apiResponse];

  return boletos
    .filter((boleto) => boleto?.prefixo)
    .map((boleto, index) => ({
      id: `${boleto.prefixo}-${boleto.numero || 'N/A'}-${boleto.parcela}`,
      vencimento: boleto.vencimento,
      valor: boleto.valor,
      diasAtraso: 0,
      juros: '0% ao dia',
      multa: 0,
      valorCorrigido: boleto.valor,
      selecionada: index === 0 && isFirstItemDisabled,
      desabilitada: index === 0 && isFirstItemDisabled,
      base64: boleto.base64,
      codigoBarras: boleto.codigoBarras || undefined,
    }));
};

export const mapApiResponsePJToBoleto = (apiResponse: BoletoApiResponsePJ, isFirstItemDisabled: boolean = true): Boleto[] => {
  if (!apiResponse.dados?.boleto || !Array.isArray(apiResponse.dados.boleto)) {
    return [];
  }

  console.log(apiResponse);
  
  return apiResponse.dados.boleto.map((item, index) => ({
    id: item.id || `${item.prefixo_titulo}-${item.numero_titulo}-${item.parcela_titulo}`,
    vencimento: new Date(item.vencimento).toLocaleDateString('pt-BR'),
    valor: item.valor,
    diasAtraso: 0,
    juros: '0% ao dia',
    multa: 0,
    valorCorrigido: item.valor,
    selecionada: index === 0 && isFirstItemDisabled,
    desabilitada: index === 0 && isFirstItemDisabled,
    arquivo_base64: item.arquivo_base64 || undefined,
    codigoBarras: item.codigo_barras || undefined,
    prefixo_titulo: item.prefixo_titulo,
    numero_titulo: item.numero_titulo,
    parcela_titulo: item.parcela_titulo,
  }));
};

export interface ApiErrorResponse {
  status: "NOK";
  mensagem: string;
  erro?: string;
}

